import React from "react";
import PropTypes from "prop-types";
import {Box, Typography, MenuItem, RadioGroup, Radio, FormControlLabel, FormControl, Checkbox, Stack} from "@mui/material";
import {MuiFileInput} from "mui-file-input";
import {AttachFile} from "@mui/icons-material";
import CustomTextField from "../common/CustomTextField";
import SignaturePadInput from "./signaturePad";

// 2 = DateTime, 4 = Yes/No, 5 = Dropdown, 6 = Checkbox Group, 8 = Date, 9 = Number,
// 10 = Photograph, 13 = Signature, 15 = Time, default = Short Text

export function TemplateInputs({inputs, onChange}) {
    const {template_requirement_input_uid: inputUid, input_requirement_config_uid: configUid, name: inputName, select = [], value} = inputs;

    function fileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    const handleText = (e) => onChange(inputUid, e.target.value);

    const handleRadio = (e) => onChange(inputUid, e.target.value);

    const handleDropdown = (e) => onChange(inputUid, e.target.value);

    const handleFile = async (file) => {
        if (file && file instanceof File) {
            const base64 = await fileToBase64(file);
            onChange(inputUid, base64);
        } else {
            onChange(inputUid, file);
        }
    };

    // const handleQRFile = async (file) => {
    //   if (file && file instanceof File) {
    //     const base64 = await fileToBase64(file);
    //     onChange(inputUid, base64);
    //   } else {
    //     onChange(inputUid, file);
    //   }
    // };

    const handleCheckbox = (e, optionUid) => {
        const checked = e.target.checked;
        const uid = Number(optionUid);
        let updatedValue = Array.isArray(inputs.value) ? [...inputs.value.map(Number)] : [];
        if (checked) {
            if (!updatedValue.includes(uid)) updatedValue.push(uid);
        } else {
            updatedValue = updatedValue.filter((v) => v !== uid);
        }
        onChange(inputUid, updatedValue);
    };

    let field = null;
    // console.log(configUid);
    switch (Number(configUid)) {
        case 2: // DateTime
            field = <CustomTextField label={inputName} type="datetime-local" onChange={handleText} value={value || ""} variant="filled" InputLabelProps={{shrink: true}} sx={{minWidth: 200}} />;
            break;

        case 4: // Yes/No confirmation
            field = (
                <FormControl sx={{my: 1}}>
                    <Typography sx={{fontWeight: 500}}>{inputName}</Typography>
                    <RadioGroup row name={`Input${inputUid}`} value={value === "Yes" || value === true ? "Yes" : "No"} onChange={handleRadio}>
                        <FormControlLabel value="No" control={<Radio />} label="No" />
                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                    </RadioGroup>
                </FormControl>
            );
            break;

        case 5: // Dropdown
            field = (
                <CustomTextField label={inputName} select onChange={handleDropdown} value={value || ""} variant="filled" sx={{minWidth: 200}}>
                    {select.map((option) => (
                        <MenuItem key={option.template_requirement_input_select_uid} value={option.name}>
                            {option.name}
                        </MenuItem>
                    ))}
                </CustomTextField>
            );
            break;

        case 6: // Checkbox list (multi-select)
            field = (
                <Box>
                    <Typography sx={{mb: 1}}>{inputName}</Typography>
                    <Stack direction="row" spacing={2}>
                        {select
                            .filter((option) => option.status === "active")
                            .map((option) => {
                                const isChecked = Array.isArray(inputs.value) && inputs.value.map(Number).includes(Number(option.template_requirement_input_select_uid));
                                return <FormControlLabel key={option.template_requirement_input_select_uid} control={<Checkbox checked={isChecked} onChange={(e) => handleCheckbox(e, option.template_requirement_input_select_uid)} color="primary" />} label={option.name} />;
                            })}
                    </Stack>
                </Box>
            );
            break;

        case 8: // Date
            field = <CustomTextField label={inputName} type="date" onChange={handleText} value={value || ""} variant="filled" InputLabelProps={{shrink: true}} sx={{minWidth: 200}} />;
            break;

        case 9: // Number
            field = <CustomTextField label={inputName} type="number" onChange={handleText} value={value || ""} variant="filled" sx={{minWidth: 200}} />;
            break;

        case 10: // Photograph/Image
            field = (
                <MuiFileInput
                    hidden
                    placeholder={inputName}
                    onChange={handleFile}
                    inputProps={{
                        accept: "image/*",
                        capture: "environment" // Enables camera if available
                    }}
                    variant="filled"
                    InputProps={{endAdornment: <AttachFile />}}
                    sx={{minWidth: 200, display: "none"}}
                />
            );
            break;

        case 11: // QR Code (treat as image)
            field = <MuiFileInput hidden placeholder={inputName} onChange={(file) => onChange(inputUid, file)} variant="filled" InputProps={{endAdornment: <AttachFile />}} inputProps={{accept: "image/*", capture: "environment"}} sx={{minWidth: 200, display: "none"}} />;
            break;

        case 13: // Signature
            field = (
                <Box hidden>
                    <Typography sx={{mb: 1}}>{inputName}</Typography>
                    <SignaturePadInput value={inputs.value} onChange={(val) => onChange(inputUid, val)} />
                </Box>
            );
            break;

        case 15: // Time
            field = <CustomTextField label={inputName} type="time" onChange={handleText} value={value || ""} variant="filled" InputLabelProps={{shrink: true}} sx={{minWidth: 200, display: "none"}} />;
            break;

        default: // Short text
            field = <CustomTextField label={inputName} onChange={handleText} value={value || ""} variant="filled" sx={{minWidth: 200}} />;
            break;
    }

    return <Box sx={{mb: 2}}>{field}</Box>;
}

TemplateInputs.propTypes = {
    inputs: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};
